import * as React from 'react';
import { Switch, Route } from 'react-router';
import { AddQuestion } from './AddQuestion';
import { QuestionList } from './QuestionList';
import { EditQuestion } from './EditQuestion';

export class Question extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route path='/dashboard/question/add' component={AddQuestion} />
        <Route path='/dashboard/question/:id' component={EditQuestion} />
        <Route exact path='/dashboard/question' component={QuestionList} />
      </Switch>
    );
  }
}
